import store from '../../redux/store';
import { isNewRealEstateUiUsed } from 'utils/state';

import {
	COMPANIES_CONNECT_MLS_REQUEST,
	COMPANIES_CONNECT_MLS_REQUEST_SUCCESS,
	COMPANIES_CONNECT_MLS_REQUEST_FAIL,

	COMPANIES_REVIEW_MLS_REQUEST,
	COMPANIES_REVIEW_MLS_REQUEST_SUCCESS,
	COMPANIES_REVIEW_MLS_REQUEST_FAIL,

	MLS_CLEAR_CONNECT_FORM_STATE,
	MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER,

	MLS_ADD_CONNECTION_WITH_OFFICE_ID,
	MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS,
	MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL,

	MLS_ADD_CONNECTION_WITH_AGENT_ID,
	MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS,
	MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL,

	MLS_GET_CONNECTIONS_LIST,
	MLS_GET_CONNECTIONS_LIST_SUCCESS,
	MLS_GET_CONNECTIONS_LIST_FAIL,

	MLS_BOARD_LIST_FETCH,
	MLS_BOARD_LIST_FETCH_SUCCESS,
	MLS_BOARD_LIST_FETCH_FAIL,

	MLS_CONNECTION_DELETE,
	MLS_CONNECTION_DELETE_SUCCESS,
	MLS_CONNECTION_DELETE_FAIL,

	MLS_OFFICE_DELETE,
	MLS_OFFICE_DELETE_SUCCESS,
	MLS_OFFICE_DELETE_FAIL,

	MLS_ADD_OFFICE_TO_CONNECTION,
	MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS,
	MLS_ADD_OFFICE_TO_CONNECTION_FAIL,

	MLS_GET_AGENTS_FOR_OFFICE,
	MLS_GET_AGENTS_FOR_OFFICE_SUCCESS,
	MLS_GET_AGENTS_FOR_OFFICE_FAIL,

	LIST_AGENT_MLS_IDS,
	LIST_AGENT_MLS_IDS_SUCCESS,
	LIST_AGENT_MLS_IDS_FAIL,

	MLS_ADD_AGENT_MLS_ID,
	MLS_ADD_AGENT_MLS_ID_SUCCESS,
	MLS_ADD_AGENT_MLS_ID_FAIL,

	MLS_EDIT_AGENT_MLS_ID,
	MLS_EDIT_AGENT_MLS_ID_SUCCESS,
	MLS_EDIT_AGENT_MLS_ID_FAIL,

	MLS_DELETE_AGENT_MLS_ID,
	MLS_DELETE_AGENT_MLS_ID_SUCCESS,
	MLS_DELETE_AGENT_MLS_ID_FAIL,

	RESOLVE_MLS_UI_TYPE
} from './actions';

import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';
import { extractPropsforSuperagentHttpError, extractPropsforAxiosHttpError } from '../../errors/errorhelper';
import { MLS_DATA_PROJECT_ENDPOINTS, MLS_UI, REAL_ESTATE_INDUSTY_ID } from '../../config';
import { showQuickMessage } from 'redux/modules/quickMessages';
import _ from 'lodash';
import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const setBoardDisplayName = (mlsBoardList) => {
	return mlsBoardList.map(board => {
		const systemName = board.systemName || '';
		const fullName = board.name || '';

		// Check if one string contains the other
		if (fullName.includes(systemName)) {
			// System Name is contained in Full Name, only display Full Name
			board.displayName = fullName;
		} else if (systemName.includes(fullName)) {
			// Full Name is contained in System Name, only display System Name
			board.displayName = systemName;
		} else {
			// Neither contains the other, display both with separator
			board.displayName = `${systemName} / ${fullName}`;
		}
		return board;
	});
};

const addNameToConnection = (mlsBoardList, connections, source) => {

	if (mlsBoardList.length && connections.length) {
		return connections.map(connectionItem => {

			const boardListItem = mlsBoardList.find(configItem => configItem.mlsBoardCode === connectionItem.mlsBoardCode);
			const connectionName = _.get(boardListItem, 'displayName', 'unknown');

			return {
				name: connectionName,
				...connectionItem,
			};

		}).sort(sortByName.bind(this, 'name'));

	} else {
		return connections;
	}

};

const sortByName = (key, a, b) => {
	const nameA = a[key].toUpperCase();
	const nameB = b[key].toUpperCase();
	if (nameA < nameB) {
		return -1;
	}
	if (nameA > nameB) {
		return 1;
	}
	return 0;
};

const initialState = {
	connectMlsSuccess: null,
	connectMlsErrorId: null,
	connectMlsXhrInProgress: false,

	reviewMlsSuccess: null,
	reviewMlsErrorId: null,
	reviewMlsXhrInProgress: false,

	addConnectionWithAgentIdSuccess: null,
	addConnectionWithAgentIdErrorId: null,
	addConnectionWithAgentIdXhrInProgress: false,

	addConnectionWithOfficeIdSuccess: null,
	addConnectionWithOfficeIdErrorId: null,
	addConnectionWithOfficeIdXhrInProgress: false,

	addMlsOfficeIdSuccess: null,
	addMlsOfficeIdErrorId: null,
	addMlsOfficeIdXhrInProgress: false,

	getConnectionsSuccess: null,
	getConnectionsErrorId: null,
	getConnectionsInProgress: false,
	connections: [],

	getAgentsMlsIdsSuccess: null,
	getAgentsMlsIdsErrorId: null,
	getAgentsMlsIdsInProgress: false,
	agentsMlsIds: null,

	deletingMlsConnectionErrorId: [],
	deletingMlsConnectionXhrInProgress: [],	

	deletingMlsOfficeErrorId: [],
	deletingMlsOfficeXhrInProgress: [],	

	mlsBoardList: [],
	mlsBoardListFailedToLoad: null,

	mlsUiType: null,

	/* adding agent mls id */
	addingAgentMlsIdXhrInProgress: [],
	addingAgentMlsIdErrorId: [],
	addingAgentMlsIdSuccess: [],

	/* editing agent mls id */
	editingAgentMlsIdXhrInProgress: [],
	editingAgentMlsIdErrorId: [],
	editingAgentMlsIdSuccess: [],

	/* deleting agent mls id */
	deletingAgentMlsIdXhrInProgress: [],
	deletingAgentMlsIdErrorId: [],
	deletingAgentMlsIdSuccess: []
};


const getCompanyIndustry = () => {
	let result = null;
	const state = store.getState();
	const companiesRawData = _.get(state, 'companies.rawDataById');

	if (companiesRawData) {
		const selectedCompanyRawData = companiesRawData[state.companies.selectedId];
		result = _.get(selectedCompanyRawData, 'industryId');
	}

	return result;
};

const isUsingCustomMlsIntegration = () => {
	let result = null;
	const state = store.getState();
	const companiesRawData = _.get(state, 'companies.rawDataById');

	if (companiesRawData) {
		const selectedCompanyRawData = companiesRawData[state.companies.selectedId];
		const selectedCompanyProviders = _.get(selectedCompanyRawData, 'dataProviders');
		result = Array.isArray(selectedCompanyProviders) && selectedCompanyProviders.length > 0;
	}

	return result;
};

export default (state = initialState, action) => {

	switch (action.type) {
		case RESOLVE_MLS_UI_TYPE:
			return {
				...state,
				mlsUiType: action.payload
			};

		case MLS_CLEAR_CONNECT_FORM_STATE:
			return {
				...state,
				connectMlsSuccess: null,
				connectMlsErrorId: null,
				connectMlsXhrInProgress: false,

				reviewMlsSuccess: null,
				reviewMlsErrorId: null,
				reviewMlsXhrInProgress: false,				

				addConnectionWithAgentIdSuccess: null,
				addConnectionWithAgentIdErrorId: null,
				addConnectionWithAgentIdXhrInProgress: false,

				addConnectionWithOfficeIdSuccess: null,
				addConnectionWithOfficeIdErrorId: null,
				addConnectionWithOfficeIdXhrInProgress: false,

				addMlsOfficeIdSuccess: null,
				addMlsOfficeIdErrorId: null,
				addMlsOfficeIdXhrInProgress: false,

				addingAgentMlsIdXhrInProgress: [],
				addingAgentMlsIdErrorId: [],
				addingAgentMlsIdSuccess: [],

				editingAgentMlsIdXhrInProgress: [],
				editingAgentMlsIdErrorId: [],
				editingAgentMlsIdSuccess: [],

				deletingAgentMlsIdXhrInProgress: [],
				deletingAgentMlsIdErrorId: [],
				deletingAgentMlsIdSuccess: []				
			};

		/* COMPANIES_CONNECT_MLS_REQUEST */
		case COMPANIES_CONNECT_MLS_REQUEST:
			return {
				...state,
				connectMlsSuccess: null,
				connectMlsErrorId: null,
				connectMlsXhrInProgress: true,
				loading: true
			};

		case COMPANIES_CONNECT_MLS_REQUEST_FAIL:	
			return {
				...state,
				connectMlsErrorId: _.get(action, 'error.errorId'),
				connectMlsXhrInProgress: false,
				loading: false
			};

		case COMPANIES_CONNECT_MLS_REQUEST_SUCCESS:
			return {
				...state,
				connectMlsErrorId: null,
				connectMlsSuccess: true,
				connectMlsXhrInProgress: false,
				loading: false
			};

		/* COMPANIES_REVIEW_MLS_REQUEST */
		case COMPANIES_REVIEW_MLS_REQUEST:
			return {
				...state,
				reviewMlsSuccess: null,
				reviewMlsErrorId: null,
				reviewMlsXhrInProgress: true,
				loading: true
			};

		case COMPANIES_REVIEW_MLS_REQUEST_FAIL:	
			return {
				...state,
				reviewMlsErrorId: _.get(action, 'error.errorId'),
				reviewMlsXhrInProgress: false,
				loading: false
			};

		case COMPANIES_REVIEW_MLS_REQUEST_SUCCESS:
			return {
				...state,
				reviewMlsErrorId: null,
				reviewMlsSuccess: true,
				reviewMlsXhrInProgress: false,
				loading: false
			};			

		/* MLS_ADD_CONNECTION_WITH_OFFICE_ID */
		case MLS_ADD_CONNECTION_WITH_OFFICE_ID:
			return {
				...state,
				addConnectionWithOfficeIdErrorId: null,
				addConnectionWithOfficeIdSuccess: null,
				addConnectionWithOfficeIdXhrInProgress: true,
				loading: true
			};

		case MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS: {
			return {
				...state,
				loading: false,
				addConnectionWithOfficeIdSuccess: true,
				addConnectionWithOfficeIdXhrInProgress: false
			};
		}

		case MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL:
			return {
				...state,
				addConnectionWithOfficeIdErrorId: _.get(action, 'error.errorId'),
				addConnectionWithOfficeIdXhrInProgress: false,
				loading: false
			};

		/* MLS_ADD_CONNECTION_WITH_AGENT_ID */
		case MLS_ADD_CONNECTION_WITH_AGENT_ID:
			return {
				...state,
				addConnectionWithAgentIdErrorId: null,
				addConnectionWithAgentIdSuccess: null,
				addConnectionWithAgentIdXhrInProgress: true,
				loading: true
			};

		case MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS: {
			return {
				...state,
				addConnectionWithAgentIdSuccess: true,
				addConnectionWithAgentIdXhrInProgress: false,
				loading: false
			};
		}			

		case MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL:
			return {
				...state,
				addConnectionWithAgentIdErrorId: _.get(action, 'error.errorId'),
				addConnectionWithAgentIdXhrInProgress: false,
				loading: false
			};
		
		/* MLS_ADD_OFFICE_TO_CONNECTION */
		case MLS_ADD_OFFICE_TO_CONNECTION:
			return {
				...state,
				addMlsOfficeIdErrorId: null,
				addMlsOfficeIdSuccess: null,
				addMlsOfficeIdXhrInProgress: true,
				loading: true
			};

		case MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS: {
			return {
				...state,
				addMlsOfficeIdSuccess: true,
				addMlsOfficeIdXhrInProgress: false,
				loading: false
			};
		}			

		case MLS_ADD_OFFICE_TO_CONNECTION_FAIL:
			return {
				...state,
				addMlsOfficeIdErrorId: _.get(action, 'error.errorId'),
				addMlsOfficeIdXhrInProgress: false,
				loading: false
			};

		/* MLS_GET_CONNECTIONS_LIST */
		case MLS_GET_CONNECTIONS_LIST:
			return {
				...state,
				getConnectionsErrorId: null,
				getConnectionsSuccess: null,
				getConnectionsInProgress: true,
				loading: true
			};

		case MLS_GET_CONNECTIONS_LIST_SUCCESS: {
			return {
				...state,
				loading: false,
				getConnectionsSuccess: true,
				getConnectionsInProgress: false,
				connections: addNameToConnection(state.mlsBoardList, action.result, 'list')	
			};
		}

		case MLS_GET_CONNECTIONS_LIST_FAIL:
			return {
				...state,
				getConnectionsErrorId: _.get(action, 'error.errorId'),
				getConnectionsInProgress: false,
				loading: false
			};

		/* LIST AGENT MLS IDS */
		case LIST_AGENT_MLS_IDS:
			return {
				...state,
				getAgentsMlsIdsErrorId: null,
				getAgentsMlsIdsSuccess: null,
				getAgentsMlsIdsInProgress: true,
				loading: true
			};

		case LIST_AGENT_MLS_IDS_SUCCESS: {
			return {
				...state,
				loading: false,
				getAgentsMlsIdsSuccess: true,
				getAgentsMlsIdsInProgress: false,
				agentsMlsIds: action.result
			};
		}

		case LIST_AGENT_MLS_IDS_FAIL:
			return {
				...state,
				getAgentsMlsIdsErrorId: _.get(action, 'error.errorId'),
				getAgentsMlsIdsInProgress: false,
				loading: false
			};


		/* MLS BOARD LIST */
		case MLS_BOARD_LIST_FETCH:
			return {
				...state,
				loading: true
			};

		case MLS_BOARD_LIST_FETCH_SUCCESS: {
			const boardList = setBoardDisplayName(action.result);
			
			return {
				...state,
				mlsBoardList: boardList.sort(sortByName.bind(this, 'displayName')),
				loading: false,
				connections: addNameToConnection(action.result, state.connections, 'config')
			};

		}

		case MLS_BOARD_LIST_FETCH_FAIL:
			return {
				...state,
				mlsBoardListFailedToLoad: true,
				loading: false
			};

		/* DELETE MLS CONNECTION */
		case MLS_CONNECTION_DELETE:
			return {
				...state,

				deletingMlsConnectionXhrInProgress: [...state.deletingMlsConnectionXhrInProgress, action.payload.mlsConnectionId],
				deletingMlsConnectionErrorId: 
					state.deletingMlsConnectionErrorId.filter(item => item.mlsConnectionId !== action.payload.mlsConnectionId),
				loading: true
			};

		case MLS_CONNECTION_DELETE_SUCCESS:
			return {
				...state,
				connections:
					state.connections.filter(connection => connection.mlsConnectionId !== action.payload.mlsConnectionId),
				deletingMlsConnectionXhrInProgress:
					state.deletingMlsConnectionXhrInProgress.filter(mlsConnectionId =>
						mlsConnectionId !== action.payload.mlsConnectionId),
				loading: false
			};

		case MLS_CONNECTION_DELETE_FAIL:
			return {
				...state,
				deletingMlsConnectionErrorId:
					[	...state.deletingMlsConnectionErrorId, 
						{ mlsConnectionId: action.payload.mlsConnectionId, errorId: _.get(action, 'error.errorId')}
					],
				deletingMlsConnectionXhrInProgress:
					state.deletingMlsConnectionXhrInProgress.filter(mlsConnectionId =>
						mlsConnectionId !== action.payload.mlsConnectionId),
				loading: false
			};			


		/* DELETE MLS OFFICE */
		case MLS_OFFICE_DELETE:
			return {
				...state,

				deletingMlsOfficeXhrInProgress: [
					...state.deletingMlsOfficeXhrInProgress,
					{ officeMlsId: action.payload.officeMlsId, mlsConnectionId: action.payload.mlsConnectionId}
				],
				deletingMlsOfficeErrorId: state.deletingMlsOfficeErrorId.filter(
					item => item.officeMlsId !== action.payload.officeMlsId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId
				),
				loading: true
			};

		case MLS_OFFICE_DELETE_SUCCESS:
			return {
				...state,

				connections: state.connections.map(
					(connection) => {
						if (connection.mlsConnectionId === action.payload.mlsConnectionId) {
							return {
								...connection,
								offices: connection.offices.filter(office => office.officeMlsId !== action.payload.officeMlsId)
							};
						} else {
							return connection;
						}
					}),

				deletingMlsOfficeXhrInProgress:
					state.deletingMlsOfficeXhrInProgress.filter(item => item.officeMlsId !== action.payload.officeMlsId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
				loading: false
			};

		case MLS_OFFICE_DELETE_FAIL:
			return {
				...state,
				deletingMlsOfficeErrorId:
					[	...state.deletingMlsOfficeErrorId, 
						{
							officeMlsId: action.payload.officeMlsId,
							mlsConnectionId: action.payload.mlsConnectionId, errorId: _.get(action, 'error.errorId')
						}
					],
				deletingMlsOfficeXhrInProgress:
					state.deletingMlsOfficeXhrInProgress.filter(item => item.officeMlsId !== action.payload.officeMlsId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				loading: false
			};			

		/* Add agent MLS id */
		case MLS_ADD_AGENT_MLS_ID: {
			return {
				...state,
				addingAgentMlsIdXhrInProgress: [
					...state.addingAgentMlsIdXhrInProgress,
					{ mlsConnectionId: action.payload.mlsConnectionId, userId: action.payload.userId}
				],
				addingAgentMlsIdErrorId: state.addingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
				addingAgentMlsIdSuccess: state.addingAgentMlsIdSuccess.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				// reset edit and delete states for same field
				editingAgentMlsIdErrorId:
					state.editingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				deletingAgentMlsIdErrorId: state.deletingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
			};
		}

		case MLS_ADD_AGENT_MLS_ID_SUCCESS: {
			return {
				...state,
				addingAgentMlsIdSuccess: [
					...state.addingAgentMlsIdSuccess, 
					{ 
						mlsConnectionId: action.payload.mlsConnectionId,
						userId: action.payload.userId
					}
				],
				addingAgentMlsIdXhrInProgress:
					state.addingAgentMlsIdXhrInProgress.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
				agentsMlsIds: [
					...state.agentsMlsIds,
					{
						_id: action.result.agentMongoId,
						companyId: action.payload.companyId, 
						userId: action.payload.userId,
						mlsConnectionId: action.payload.mlsConnectionId,
						agentMlsId: action.payload.agentMlsId
					}
				],
				loading: false
			};			
		}

		case MLS_ADD_AGENT_MLS_ID_FAIL: {
			return {
				...state,
				addingAgentMlsIdErrorId:
					[	...state.addingAgentMlsIdErrorId, 
						{
							mlsConnectionId: action.payload.mlsConnectionId,
							userId: action.payload.userId,
							errorId: _.get(action, 'error.errorId'),
							agentMlsId: action.payload.agentMlsId,
							forceAddition: action.payload.forceAddition
						}
					],
				addingAgentMlsIdXhrInProgress:
					state.addingAgentMlsIdXhrInProgress.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId)
			};
		}

		/* edit agent MLS id */
		case MLS_EDIT_AGENT_MLS_ID: {
			return {
				...state,
				editingAgentMlsIdXhrInProgress: [
					...state.editingAgentMlsIdXhrInProgress,
					{ 
						mlsConnectionId: action.payload.mlsConnectionId,
						userId: action.payload.userId,
						agentMongoId: action.payload.agentMongoId
					}
				],
				editingAgentMlsIdErrorId:
					state.editingAgentMlsIdErrorId.filter(item => item.agentMongoId !== action.payload.agentMongoId),
				editingAgentMlsIdSuccess:
					state.editingAgentMlsIdSuccess.filter(item => item.agentMongoId !== action.payload.agentMongoId),

				// reset add and delete states for same field
				addingAgentMlsIdErrorId:
					state.addingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				deletingAgentMlsIdErrorId: state.deletingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
			};
		}

		case MLS_EDIT_AGENT_MLS_ID_SUCCESS: {
			return {
				...state,
				editingAgentMlsIdSuccess: [
					...state.editingAgentMlsIdSuccess, 
					{ 
						mlsConnectionId: action.payload.mlsConnectionId,
						userId: action.payload.userId,
						agentMongoId: action.payload.agentMongoId,
					}
				],
				editingAgentMlsIdXhrInProgress:
					state.editingAgentMlsIdXhrInProgress.filter(item => item.agentMongoId !== action.payload.agentMongoId),
				agentsMlsIds: state.agentsMlsIds.map(agentItem => {

					if (agentItem._id === action.payload.agentMongoId) {
						return {
							...agentItem,
							agentMlsId: action.payload.newAgentMlsId
						};
					} else {
						return agentItem;
					}

				}),
				loading: false
			};			
		}

		case MLS_EDIT_AGENT_MLS_ID_FAIL: {
			return {
				...state,
				editingAgentMlsIdErrorId:
					[	...state.editingAgentMlsIdErrorId, 
						{
							mlsConnectionId: action.payload.mlsConnectionId,
							userId: action.payload.userId,
							errorId: _.get(action, 'error.errorId'),
							agentMongoId: action.payload.agentMongoId,
							agentMlsId: action.payload.newAgentMlsId,
							forceAddition: action.payload.forceAddition
						}
					],
				editingAgentMlsIdXhrInProgress:
					state.editingAgentMlsIdXhrInProgress.filter(item => item.agentMongoId !== action.payload.agentMongoId)
			};
		}		
		
		/* delete agent MLS id */
		case MLS_DELETE_AGENT_MLS_ID: {
			return {
				...state,
				deletingAgentMlsIdXhrInProgress: [
					...state.deletingAgentMlsIdXhrInProgress,
					{
						mlsConnectionId: action.payload.mlsConnectionId,
						userId: action.payload.userId,
						agentMongoId: action.payload.agentMongoId
					}
				],
				deletingAgentMlsIdErrorId: state.deletingAgentMlsIdErrorId.filter(item =>
					item.agentMongoId !== action.payload.agentMongoId),
				deletingAgentMlsIdSuccess: state.deletingAgentMlsIdSuccess.filter(item =>
					item.agentMongoId !== action.payload.agentMongoId),

				// reset add and edit states for same field
				addingAgentMlsIdErrorId:
					state.addingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				editingAgentMlsIdErrorId:
					state.editingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),
			};
		}

		case MLS_DELETE_AGENT_MLS_ID_SUCCESS: {
			return {
				...state,
				deletingAgentMlsIdSuccess: [
					...state.deletingAgentMlsIdSuccess, 
					{ 
						mlsConnectionId: action.payload.mlsConnectionId,
						userId: action.payload.userId,
						agentMongoId: action.payload.agentMongoId,
					}
				],
				deletingAgentMlsIdXhrInProgress:
					state.deletingAgentMlsIdXhrInProgress.filter(item => item.agentMongoId !== action.payload.agentMongoId),

				agentsMlsIds:
					state.agentsMlsIds.filter(item => item._id !== action.payload.agentMongoId),
				loading: false
			};			
		}

		case MLS_DELETE_AGENT_MLS_ID_FAIL: {
			return {
				...state,
				deletingAgentMlsIdErrorId:
					[	...state.deletingAgentMlsIdErrorId, 
						{
							mlsConnectionId: action.payload.mlsConnectionId,
							userId: action.payload.userId,
							errorId: _.get(action, 'error.errorId'),
							agentMongoId: action.payload.agentMongoId,
						}
					],
				deletingAgentMlsIdXhrInProgress:
					state.deletingAgentMlsIdXhrInProgress.filter(item => item.agentMongoId !== action.payload.agentMongoId)
			};
		}		
		
		case MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER:
			return {
				...state,

				addingAgentMlsIdErrorId: state.addingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				editingAgentMlsIdErrorId:
					state.editingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
						item.mlsConnectionId !== action.payload.mlsConnectionId),

				deletingAgentMlsIdErrorId: state.deletingAgentMlsIdErrorId.filter(item => item.userId !== action.payload.userId &&
					item.mlsConnectionId !== action.payload.mlsConnectionId),
			};		

		default:
			return state;
	}
};

/* used when sending request for mls not listed in RE-api */
export const sendConnectMlsRequest = (data) => {
	return {
		types: [COMPANIES_CONNECT_MLS_REQUEST, COMPANIES_CONNECT_MLS_REQUEST_SUCCESS, COMPANIES_CONNECT_MLS_REQUEST_FAIL],
		promise: client => client.post(MLS_DATA_PROJECT_ENDPOINTS.CONNECT_MLS, data)
			.catch((error) => {
				const httpErrorProps = extractPropsforAxiosHttpError(error);
				const nError = new AppError({
					message: 'mls.sendConnectMlsRequest() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
	};
};

/* used when user has invalid officeId or agentId */
export const sendMlsReviewRequest = (data) => {
	return {
		types: [COMPANIES_REVIEW_MLS_REQUEST, COMPANIES_REVIEW_MLS_REQUEST_SUCCESS, COMPANIES_REVIEW_MLS_REQUEST_FAIL],
		promise: client => client.post(MLS_DATA_PROJECT_ENDPOINTS.REVIEW_MLS, data)
			.catch((error) => {
				const httpErrorProps = extractPropsforAxiosHttpError(error);
				const nError = new AppError({
					message: 'mls.sendMlsReviewRequest() failed',
					errorId: ERRORS.UNKNOWN,
					errorDetails: data,					
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
	};
};

/**
 * Clear Add MLS form state
 */
export const clearConnectMlsState = () => {
	return dispatch => {
		dispatch({
			type: MLS_CLEAR_CONNECT_FORM_STATE
		});
	};
};

export const addMLSConnectionWithAgentId = (mlsBoardCode, agentMlsId, forceAddition) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_ADD_CONNECTION_WITH_AGENT_ID,
				MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS,
				MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL],
			payload: { mlsBoardCode, agentMlsId, forceAddition },
			promise: client => client.post(
				`/mls-connections/companies/${selectedId}/mlsConnections/agents/${encodeURIComponent(agentMlsId)}`,
				{ data: { mlsBoardCode, forceAddition } }
			).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.addMLSConnectionWithAgentId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const addMLSConnectionWithOfficeId = (mlsBoardCode, officeMlsId, forceAddition) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_ADD_CONNECTION_WITH_OFFICE_ID,
				MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS,
				MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL],
			payload: { mlsBoardCode, officeMlsId, forceAddition },
			promise: client => client.post(
				`/mls-connections/companies/${selectedId}/mlsConnections/mlsOffices/${encodeURIComponent(officeMlsId)}`, 
				{ data: { mlsBoardCode, forceAddition } }
			).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.addMLSConnectionWithOfficeId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

export const getConnectionList = () => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [
				MLS_GET_CONNECTIONS_LIST,
				MLS_GET_CONNECTIONS_LIST_SUCCESS,
				MLS_GET_CONNECTIONS_LIST_FAIL],
			promise: client => client.get(`/mls-connections/companies/${selectedId}/mlsConnections`)
				.then(response => {
					return response;
				})			
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.getConnectionList() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const fetchMlsBoards = () => {
	return (dispatch) => {
		return dispatch({
			types: [
				MLS_BOARD_LIST_FETCH, MLS_BOARD_LIST_FETCH_SUCCESS, MLS_BOARD_LIST_FETCH_FAIL],
			promise: client => client.get('/mls-connections/mls-boards/config')
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.fetchMlsBoards() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const deleteMLSConnection = (mlsConnectionId, mlsBoardCode) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;

		return dispatch({
			types: [MLS_CONNECTION_DELETE, MLS_CONNECTION_DELETE_SUCCESS, MLS_CONNECTION_DELETE_FAIL],
			payload: { mlsConnectionId },
			promise: client => client.delete(`/mls-connections/companies/${selectedId}/mlsConnections/${mlsConnectionId}`)
				.then(() => {
					showQuickMessage(localize('mls-connection-removed', mlsBoardCode)).call(this, dispatch);
				}).catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.deleteMLSConnection() failed',
						errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const deleteOfficeId = (mlsConnectionId, officeMlsId, officeName) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;

		return dispatch({
			types: [MLS_OFFICE_DELETE, MLS_OFFICE_DELETE_SUCCESS, MLS_OFFICE_DELETE_FAIL],
			payload: { mlsConnectionId, officeMlsId },
			promise: client => client.delete(
				// eslint-disable-next-line max-len
				`/mls-connections/companies/${selectedId}/mlsConnections/${mlsConnectionId}/mlsOffices/${encodeURIComponent(officeMlsId)}`
			)
				.then(() => {
					showQuickMessage(localize('mls-office-removed', officeName)).call(this, dispatch);
				}).catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.deleteOfficeId() failed',
						errorId: httpErrorProps.errorId || ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const addOfficeId = (mlsConnectionId, officeMlsId, forceAddition) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_ADD_OFFICE_TO_CONNECTION,
				MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS,
				MLS_ADD_OFFICE_TO_CONNECTION_FAIL],
			payload: { mlsConnectionId, officeMlsId, forceAddition },
			promise: client => client.post(
				// eslint-disable-next-line max-len
				`/mls-connections/companies/${selectedId}/mlsConnections/${mlsConnectionId}/mlsOffices/${encodeURIComponent(officeMlsId)}`,
				{data: { forceAddition }}
			).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.addOfficeId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};
};

/* for mlsStart1 returns only total count */
export const getMlsAgentsForOffice = (officeMlsId) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [
				MLS_GET_AGENTS_FOR_OFFICE,
				MLS_GET_AGENTS_FOR_OFFICE_SUCCESS,
				MLS_GET_AGENTS_FOR_OFFICE_FAIL],
			promise: client => client.get(`/companies/${selectedId}/connectionlist/${officeMlsId}`)
				.then(response => {
					return response.agents_count;
				})			
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.getMlsAgentsForOffice() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

export const addAgentMlsId = (mlsConnectionId, userId, agentMlsId, forceAddition) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_ADD_AGENT_MLS_ID,
				MLS_ADD_AGENT_MLS_ID_SUCCESS,
				MLS_ADD_AGENT_MLS_ID_FAIL],
			payload: { mlsConnectionId, userId, agentMlsId, forceAddition, companyId: selectedId },
			promise: client => client.post(`/agent-mls-ids/companies/${selectedId}/mlsConnections/${mlsConnectionId}/agents`, {
				data: { userId, agentMlsId, forceAddition }
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.addAgentMlsId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};	
};

export const editAgentMlsId = (mlsConnectionId, userId, newAgentMlsId, agentMongoId, forceAddition) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_EDIT_AGENT_MLS_ID,
				MLS_EDIT_AGENT_MLS_ID_SUCCESS,
				MLS_EDIT_AGENT_MLS_ID_FAIL],
			payload: { mlsConnectionId, userId, newAgentMlsId, agentMongoId, forceAddition },
			promise: client => client.put(
				`/agent-mls-ids/companies/${selectedId}/mlsConnections/${mlsConnectionId}/agents/${agentMongoId}`, 
				{ data: { userId, newAgentMlsId, forceAddition }}
			).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.editAgentMlsId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};	
};

export const deleteAgentMlsId = (mlsConnectionId, userId, agentMongoId) => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [MLS_DELETE_AGENT_MLS_ID,
				MLS_DELETE_AGENT_MLS_ID_SUCCESS,
				MLS_DELETE_AGENT_MLS_ID_FAIL],
			payload: { mlsConnectionId, userId, agentMongoId },
			promise: client => client.delete(
				`/agent-mls-ids/companies/${selectedId}/mlsConnections/${mlsConnectionId}/agents/${agentMongoId}`,
				{ data: { mlsConnectionId, userId }}
			).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'mls.deleteAgentMlsId() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_COMPANIES' }
				});

				throw nError;
			})
		});
	};	
};

export const getAgentMlsIds = () => {
	return (dispatch, getState) => {
		const { selectedId } = getState().companies;
		return dispatch({
			types: [
				LIST_AGENT_MLS_IDS,
				LIST_AGENT_MLS_IDS_SUCCESS,
				LIST_AGENT_MLS_IDS_FAIL],
			promise: client => client.get(`/agent-mls-ids/companies/${selectedId}`)
				.catch((error) => {
					const httpErrorProps = extractPropsforSuperagentHttpError(error);
					const nError = new AppError({
						message: 'mls.getAgentMlsIds() failed',
						errorId: ERRORS.UNKNOWN,
						originalError: new HttpError(httpErrorProps),
						visualisers: { feature: 'REDUX_COMPANIES' }
					});

					throw nError;
				})
		});
	};
};

/**
 * Resolve MLS UI type
 */
export const resolveMLsUiType = () => {
	const isCustomMlsIntegration = isUsingCustomMlsIntegration();
	const companyIndustry = getCompanyIndustry();

	let uiType = null;
	if (companyIndustry === REAL_ESTATE_INDUSTY_ID || isNewRealEstateUiUsed(store)) {
		uiType = isCustomMlsIntegration ? MLS_UI.DIRECT_MLS_API : MLS_UI.SELF_CONNECT_API;
	}

	return {
		type: RESOLVE_MLS_UI_TYPE,
		payload: uiType
	};
};

export const clearErrorsForConnectionAndUser = (mlsConnectionId, userId) => {
	return dispatch => {
		dispatch({
			type: MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER,
			payload: {
				mlsConnectionId, userId
			}
		});
	};
};


// WEBPACK FOOTER //
// ./src/redux/modules/mls.js